// CUSTOM DEVELOPMENT FOR CUSTOMER - START
class ProductCustomVariant extends HTMLElement {
  constructor() {
    super();

    this.variantProduct = this.dataset.customVariantProduct;
    this.firstOption = this.querySelector(
      ".custom-variant__options--option-1 input"
    );
    this.switchOption = this.querySelector(
      ".custom-variant__options--option-2 input"
    );
    this.customVariantPrice = this.querySelector(".custom-variant__price");
    this.selectedOptions = {};
    this.variantId = null;
    this.productForm = document.querySelector("product-form");
    this.cartDrawer = document.querySelector("cart-drawer");

    if (this.switchOption) {
      this.switchOption.addEventListener("change", () => this.toggleDots());
    }

    this.productForm.addEventListener("submit", (e) => this.handleSubmit(e));

    this.init();
  }

  init() {
    const optionGroups = this.querySelectorAll(".custom-variant__options");

    optionGroups.forEach((group) => {
      const optionGroupName = group.getAttribute("data-variants-option-name");

      switch (optionGroupName) {
        case "option1":
          this.handleOption1(group);
          break;
        case "option2":
          this.handleOption2(group);
          break;
        case "option3":
          this.handleOption3(group);
          break;
      }
    });
  }

  handleOption1(group) {
    const input = group.querySelector("input");
    const optionValues = JSON.parse(group.dataset.variantsOptionsData)[0]
      .values;

    input.addEventListener("input", (e) => {
      const value = e.target.value.replace(/\./g, "");
      const length = value.length;
      const index = Math.min(length - 1, 2);
      this.selectedOptions["option1"] = optionValues[index];

      this.toggleAdditionalOptions(length > 0);
      this.updateVariantPrice();
    });
  }

  handleOption2(group) {
    const input = group.querySelector("input");
    const optionValues = JSON.parse(group.dataset.variantsOptionsData)[0]
      .values;

    input.addEventListener("change", (e) => {
      this.selectedOptions["option2"] = e.target.checked
        ? optionValues[1]
        : optionValues[0];
      this.toggleDots();
      this.updateVariantPrice();
    });
  }

  handleOption3(group) {
    const inputs = group.querySelectorAll("input");

    inputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        this.selectedOptions["option3"] = e.target.value;
        this.updateVariantPrice();
      });
    });
  }

  toggleDots() {
    const value = this.firstOption.value.replace(/\./g, "");
    const placeholder = this.firstOption.placeholder.replace(/\./g, "");

    if (this.switchOption.checked) {
      const newValue = value.split("").join(".") + ".";
      const newPlaceholder = placeholder.split("").join(".") + ".";
      this.firstOption.value = newValue;
      this.firstOption.placeholder = newPlaceholder;
    } else {
      this.firstOption.value = value;
      this.firstOption.placeholder = placeholder;
    }
  }

  ensureDots() {
    if (this.switchOption.checked && !this.firstOption.value.includes(".")) {
      this.toggleDots();
    }
  }

  toggleAdditionalOptions(show) {
    const elements = this.querySelectorAll(
      ".custom-variant__label--option-2, .custom-variant__label--option-3, .custom-variant__options--option-2, .custom-variant__options--option-3"
    );
    elements.forEach((element) => {
      element.classList.toggle("hidden", !show);
    });
  }

  async updateVariantPrice() {
    const variant = await this.getVariant();
    if (variant) {
      this.customVariantPrice.textContent = (variant.price / 100).toFixed(0);
    }
  }

  async getVariant() {
    const productInfo = document.querySelector("product-info");
    const swatchKingElements = productInfo.querySelectorAll("variant-swatch-king");

    if (swatchKingElements.length === 0) {
      console.error("SwatchKing elements are not initialized yet.");
      return null;
    }

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}products/${this.variantProduct}.js`
      );
      const productData = await response.json();
      const variants = productData.variants || [];

      return variants.find((variant) =>
        Object.keys(this.selectedOptions).every(
          (key) => this.selectedOptions[key] === variant[key]
        )
      );
    } catch (error) {
      console.error("Error fetching product data:", error);
      return null;
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.ensureDots();

    if (this.firstOption.value.length !== 0) {
      this.getVariant().then((variant) => {
        if (variant && variant.id) {
          this.variantId = variant.id;
          this.addToCart();
        } else {
          console.error("Variant not found.");
        }
      });
    }
  }

  addToCart() {
    const waitForProductVariantId = (resolve) => {
      const formAddToCart = document.querySelector(
        'form[data-type="add-to-cart-form"]'
      );
      const productVariantIdInput =
        formAddToCart?.querySelector('input[name="id"]');

      if (productVariantIdInput?.value) {
        setTimeout(() => {
          const formData = {
            items: [
              {
                id: this.variantId,
                quantity: 1,
                properties: {
                  Initials: this.firstOption.value,
                  Product: `${this.dataset.productHandle} --- ${productVariantIdInput.value}`,
                },
              },
            ],
            sections: this.cartDrawer
              .getSectionsToRender()
              .map((section) => section.section),
          };

          fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
          })
            .then((res) => res.json())
            .then((response) => {
              this.cartDrawer.renderContents(response);
              this.updateCartCount();
            })
            .catch((error) => console.error("Error adding to cart:", error));

          resolve();
        }, 1000);
      } else {
        setTimeout(() => waitForProductVariantId(resolve), 100);
      }
    };

    return new Promise(waitForProductVariantId);
  }

  updateCartCount() {
    fetch("/cart.json")
      .then((res) => res.json())
      .then((data) => {
        const cartDrawerCounter = document.querySelector(
          ".cart-drawer__title-counter"
        );
        cartDrawerCounter.textContent = data.item_count;
      });
  }
}

customElements.define("product-custom-variant", ProductCustomVariant);
// CUSTOM DEVELOPMENT FOR CUSTOMER - END


